import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[countryCode]/(main)/informacion/politica-de-cookies/open-cookie-settings.tsx");
